/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q7Inputs */

const en_pc_dl_faq_q7 = /** @type {(inputs: Pc_Dl_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does PdfCraft update itself?`)
};

const zh_pc_dl_faq_q7 = /** @type {(inputs: Pc_Dl_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 会自动更新吗？`)
};

/**
* | output |
* | --- |
* | "Does PdfCraft update itself?" |
*
* @param {Pc_Dl_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q7 = /** @type {((inputs?: Pc_Dl_Faq_Q7Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q7Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q7(inputs)
	return zh_pc_dl_faq_q7(inputs)
});
export { pc_dl_faq_q7 as "pc.dl.faq.q7" }